import {
  Component,
  ContentChild,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
  TemplateRef,
} from '@angular/core';
import { StepComponent } from '../step/step.component';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'split-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss'],
})
export class StepsComponent {
  totalSteps: number = 0;

  @Output() stepChange = new EventEmitter<number>();

  // Correção na tipagem para TemplateRef
  @ContentChild('customPreviousButton') customPreviousButton:
    | TemplateRef<any>
    | undefined;
  @ContentChild('customNextButton') customNextButton:
    | TemplateRef<any>
    | undefined;

  // dependendo do valor de active index um certo step será exibido
  @Input() activeIndex: number = 0;

  @ContentChildren(StepComponent) inputSteps!: QueryList<StepComponent>;
  public steps!: StepComponent[];

  @Output() onStepChange = new EventEmitter<StepComponent>();

  //variavel que controla qual step é DISABLE e qual não é
  @Input() isNextStepEnabled: boolean = true;
   //variavel que controla qual step é DISABLE do meio
  @Input() isStepDisabled: boolean = false;

  @Input() errors: any[] = [];

  protected readonly environmentText: any = {
    unitName: 'Nome da Unidade',
    contactNumber: 'Celular',
    contactEmail: 'E-mail',
    registrationNumber: 'CNPJ',
    postalCode: 'CEP',
    district: 'Bairro',
    city: 'Cidade',
    streetAddress: 'Endereço',
    number: 'Número',
    ibge: 'IBGE',
    state: 'UF',
    address2: 'Complemento',
    country: 'País',
    name: 'Nome',
    monthlyIncomeManager: 'Rendimento mensal',
    taxId: 'CPF',
    birthdate: 'Data de nascimento',
    emailProfessional: 'E-mail profissional',
    tradeName: 'Nome Fantasia',
    legalName: 'Razão Social',
    taxRegime: 'Regime Tributário',
    specialRegime: 'Regime Especial',
    municipalRegistration: 'Inscrição Municipal',
  };


  //nessa função temos a verificação se chegamos no ultimo step (deve ser desativado o botão) ou se a condição para prosseguir não está sendo feita
  nextStep(): void {
    if (
      this.activeIndex < this.totalSteps - 1 &&
      this.isNextStepEnabled
    ) {
      this.activeIndex++;
      if(this.steps[this.activeIndex].ignoreStep == true) {
        this.nextStep();
      } else {
        this.stepChange.emit(this.activeIndex);
        this.onStepChange.emit(this.steps[this.activeIndex]);
      }

    }
    //console.log(this.activeIndex);
    //console.log(this.isNextStepEnabled);
  }

  public ngAfterContentInit(): void {
    this.inputSteps.forEach((tab) => {
      //console.log(tab.template);
    });
    this.steps = this.inputSteps.toArray();
    this.totalSteps = this.steps.length;

    this.inputSteps.changes.subscribe((queryChanges) => {
      this.steps = this.inputSteps.toArray();
      this.totalSteps = this.steps.length;

      //console.log('query changes:', queryChanges)
    });
  }

  //serve para ser o array das bolinha algo do tipo
  get stepsArray(): any[] {
    return Array(this.totalSteps).fill(0);
  }

  //outros

  // Função para definir o índice ativo ao clicar em uma bolinha
  setActiveIndex(index: number): void {
    this.activeIndex = index;
    
  }

  // Função para ir para o próximo passo
  // nextStep(): void {
  //   if (this.activeIndex < this.totalSteps - 1) {
  //     this.activeIndex++;
  //     this.stepChange.emit(this.activeIndex);
  //   }
  // }

  // Função para voltar para o passo anterior
  previousStep(): void {
    if (this.activeIndex > 0) {
      this.activeIndex--;
      if(this.steps[this.activeIndex].ignoreStep == true) {
        this.previousStep();
      } else {
        this.stepChange.emit(this.activeIndex);
        this.onStepChange.emit(this.steps[this.activeIndex]);
      }
    }
  }
}
